export default {
  "content": "<path d=\"M12 10a2 2 0 110 4 2 2 0 010-4z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 6c2.391 0 4.531 1.018 6.15 2.113a18.634 18.634 0 013.334 2.917 1.45 1.45 0 010 1.94 18.634 18.634 0 01-3.333 2.917C16.53 16.982 14.39 18 12 18c-2.392 0-4.532-1.018-6.152-2.113a18.637 18.637 0 01-3.333-2.917 1.45 1.45 0 010-1.94l.225-.245a18.658 18.658 0 013.108-2.672C7.468 7.018 9.608 6 12 6zm0 2c-1.834 0-3.58.789-5.03 1.77A16.602 16.602 0 004.345 12c.551.575 1.465 1.446 2.623 2.23C8.421 15.21 10.166 16 12 16c1.834 0 3.58-.789 5.03-1.77A16.592 16.592 0 0019.653 12a16.591 16.591 0 00-2.622-2.23C15.579 8.79 13.833 8 12 8z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};